var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-warp"},[_c('div',{staticClass:"loading-border"},[_c('div',{staticClass:"loading-border-warp"},[_c('div'),_c('div'),_c('div'),_c('div')])]),_c('div',{staticClass:"loading-dot"})])
}]

export { render, staticRenderFns }